// hooks/useEvents.js
import { useState, useEffect } from "react";
import { useHygraph } from "./useHygraph";

export const useEvents = () => {
  const [esdeveniments, setEsdeveniments] = useState([]);
  const { fetchFromHygraph, loading, error } = useHygraph();

  const getEsdeveniments = async () => {
    const query = `
      {
        esdeveniments(first: 100) {
          titol
          descripcio
          data
          imatge {
            url
          }
        }
      }
    `;

    const data = await fetchFromHygraph(query);
    if (data && data.esdeveniments) {
      // Ordenem els esdeveniments per data (de més recent a més antic)
      const sortedEvents = [...data.esdeveniments].sort((a, b) => {
        // Convertim les dates a objectes Date per poder comparar-les
        const dateA = new Date(a.data);
        const dateB = new Date(b.data);

        // Retornem la diferència entre les dates (ordenació descendent: de més recent a més antic)
        return dateA - dateB;
      });

      setEsdeveniments(sortedEvents);
    }
  };

  useEffect(() => {
    getEsdeveniments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    esdeveniments,
    loadingEsdeveniments: loading,
    errorEsdeveniments: error,
    refreshEsdeveniments: getEsdeveniments,
  };
};
